import type { FC } from 'react';
import React from 'react';

import type { BaseSvgProps } from '../../utils';
import { sizeToSvgWidth } from '../../utils';

export const FragmentLogo: FC<BaseSvgProps> = ({
  width = sizeToSvgWidth.sm,
  'data-testid': testId = 'paymentbadge',
}) => (
  <svg
    width={width}
    height={width}
    className="shrink-0"
    data-testid={testId}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="12" height="12" fill="rgb(var(--colour-main))" />
    {/* centres the 305-unit source artwork's glyph bbox in the 12x12 badge */}
    <g transform="translate(-5.1325 -5.1325) scale(0.073)">
      <path
        d="M116.278 202.188V102.812H188.722V115.767H131.278V144.745H181.904V157.699H131.278V202.188H116.278Z"
        fill="rgb(var(--colour-negative))"
      />
    </g>
  </svg>
);
